export function exhaustivenessCheck(value: never): never {
    const error = new Error(`Unhandled case: ${JSON.stringify(value)}`);

    if (process.env.NODE_ENV !== 'production') {
        throw error;
    }

    console.error(error); // eslint-disable-line no-console

    return undefined as never;
}
